<template>
    <Container>
        <GridContainer class="hanq-container">
            <!-- !대여연장관리 섹션 -->
            <GridItem>
                <SectionHeader>
                    <Title>일반 대여 <Count type="basic">{{ basicTotalItems }}건</Count>
                    </Title>
                </SectionHeader>

                <SearchSection>
                    <SearchGroup>
                        <SearchSelect v-model="statusFilterSelect" @change="applyStatusFilterSelect('basic')">
                            <option value="">상태검색</option>
                            <!-- <option value="delivery_0">배송대기</option> -->
                            <!-- <option value="delivery_1">배송중</option> -->
                            <!-- <option value="delivery_2">배송완료</option> -->
                            <!-- <option value="delivery_3">회수중</option> -->
                            <option value="delivery_4">회수완료</option>
                            <!-- <option value="rental_1">대여중</option> -->
                            <!-- <option value="rental_2">대여중지</option> -->
                        </SearchSelect>
                        <SearchInput v-model="basicSearchQuery" type="text" placeholder="수급자 검색"
                            @keyup.enter="fetchRentals('basic')" />
                        <HanqBtn @click="fetchRentals('basic')">
                            <Magnify />
                        </HanqBtn>

                        <AllButton :class="{ active: basicSelectedMonth === null }"
                            @click="searchByMonth(null, 'basic')">
                            전체
                        </AllButton>
                    </SearchGroup>
                    <DateRange>
                        <Datepicker v-model:value="basicStartDate" style="width: 120px;" :lang="ko" />
                        ~
                        <Datepicker v-model:value="basicEndDate" style="width: 120px;" :lang="ko" />
                        <SearchButton @click="fetchRentals('basic')">날짜조회</SearchButton>
                    </DateRange>
                </SearchSection>
                <Table>
                    <colgroup>
                        <col width="6%" /> <!-- No -->
                        <col width="10%" /> <!-- 성함 -->
                        <col width="25%" /> <!-- 품목명 -->
                        <col width="8%" /> <!-- 담당자 -->
                        <col width="14%" /> <!-- 대여시작일 -->
                        <col width="14%" /> <!-- 대여종료일 -->
                        <col width="10%" /> <!-- 대여상태 -->
                        <col width="12%" /> <!-- 배송상태 -->
                    </colgroup>
                    <thead>
                        <tr>
                            <th>No</th>
                            <th>성함</th>
                            <th>품목명</th>
                            <th>담당자</th>
                            <th>대여시작일</th>
                            <th>대여종료일</th>
                            <th>대여상태</th>
                            <th>배송상태</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(rental, i) in basicRentals" :key="rental.num" @click="openOrderRentalModal(rental)"
                            :class="{ 'ending-soon': isRentalEndingSoon(rental.rental_end), 'blurred': isTestUser }">
                            <td>{{ ((currentPage - 1) * 10) + i + 1 }}</td>
                            <td>{{ rental.name }}</td>
                            <td>{{ formatProductName(rental.product_name) }}</td>
                            <td>{{ rental.manager }}</td>
                            <td>{{ rental.rental_start }}</td>
                            <td>{{ rental.rental_end }}</td>
                            <td>
                                <StatusBadge :class="`rental-${rental.rental_status}`">
                                    {{ $rental_status(rental.rental_status) }}
                                </StatusBadge>
                            </td>
                            <td>
                                <StatusBadge :class="`delivery-${rental.delivery_status}`">
                                    {{ $delivery_status(rental.delivery_status) || '-' }}
                                </StatusBadge>
                            </td>
                        </tr>
                    </tbody>
                </Table>
                <!-- * 페이지네이션 -->
                <PaginationContainer v-if="basicTotalItems > 10">
                    <PaginationButton :disabled="basicCurrentPage === 1" @click="changePage(1, 'basic')">
                        <ChevronDoubleLeft :size="17" class="chevron-icon" />
                    </PaginationButton>
                    <PaginationButton :disabled="basicCurrentPage === 1"
                        @click="changePage(basicCurrentPage - 1, 'basic')">
                        <ChevronLeft :size="17" class="chevron-icon" />
                    </PaginationButton>
                    <PaginationNumbers>
                        <PaginationNumber v-for="page in Math.ceil(basicTotalItems / 10)" :key="page"
                            :class="{ active: basicCurrentPage === page }" @click="changePage(page, 'basic')">
                            {{ page }}
                        </PaginationNumber>
                    </PaginationNumbers>
                    <PaginationButton :disabled="basicCurrentPage === Math.ceil(basicTotalItems / 10)"
                        @click="changePage(basicCurrentPage + 1, 'basic')">
                        <ChevronRight :size="17" class="chevron-icon" />
                    </PaginationButton>
                    <PaginationButton :disabled="basicCurrentPage === Math.ceil(basicTotalItems / 10)"
                        @click="changePage(Math.ceil(basicTotalItems / 10), 'basic')">
                        <ChevronDoubleRight :size="17" class="chevron-icon" />
                    </PaginationButton>
                </PaginationContainer>
            </GridItem>

            <!-- !산소발생기 청구 및 대여 섹션 -->
            <GridItem>
                <SectionHeader>
                    <Title>산소발생기 청구<Count type="oxygen">{{ oxygenTotalItems }}건</Count>
                        <ManageButton @click="openOxygenModal">
                            <span>산소발생기 관리</span>
                        </ManageButton>
                    </Title>
                </SectionHeader>

                <SearchSection>
                    <SearchGroup>
                        <SearchInput v-model="oxygenSearchQuery" placeholder="수급자 검색"
                            @keyup.enter="fetchRentals('oxygen')" />
                        <HanqBtn @click="fetchRentals('oxygen')">
                            <Magnify />
                        </HanqBtn>

                        <AllButton :class="{ active: oxygenSelectedMonth === null }"
                            @click="searchByMonth(null, 'oxygen')">
                            전체
                        </AllButton>
                    </SearchGroup>
                    <DateRange>
                        <Datepicker v-model:value="oxygenStartDate" placeholder="시작일" style="width: 120px;"
                            :lang="ko" />
                        ~
                        <Datepicker v-model:value="oxygenEndDate" placeholder="종료일" style="width: 120px;" :lang="ko" />
                        <SearchButton @click="fetchRentals('oxygen')">날짜조회</SearchButton>
                    </DateRange>
                </SearchSection>
                <Table>
                    <colgroup>
                        <col width="6%" /> <!-- No -->
                        <col width="8%" /> <!-- 성함 -->
                        <col width="15%" /> <!-- 품목명 -->
                        <col width="8%" /> <!-- 담당자 -->
                        <col width="14%" /> <!-- 대여시작일 -->
                        <col width="14%" /> <!-- 대여종료일 -->
                        <col width="10%" /> <!-- 대여상태 -->
                        <col width="12%" /> <!-- 배송상태 -->
                        <!-- <col width="9%" /> 청구여부 -->
                    </colgroup>
                    <thead>
                        <tr>
                            <th>No</th>
                            <th>성함</th>
                            <th>품목명</th>
                            <th>담당자</th>
                            <th>대여시작일</th>
                            <th>대여종료일</th>
                            <th>대여상태</th>
                            <th>배송상태</th>
                            <!-- <th>청구여부</th> -->
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(rental, i) in oxygenRentals" :key="rental.num" @click="openOrderRentalModal(rental)"
                            :class="{ 'ending-soon': isRentalEndingSoon(rental.rental_end), 'blurred': isTestUser }">
                            <td>{{ ((oxygenCurrentPage - 1) * 10) + i + 1 }}</td>
                            <td>{{ rental.name }}</td>
                            <td>{{ formatProductName(rental.product_name) }}</td>
                            <td>{{ rental.manager }}</td>
                            <td>{{ rental.rental_start }}</td>
                            <td>{{ rental.rental_end }}</td>
                            <td>
                                <StatusBadge :class="`rental-${rental.rental_status}`">
                                    {{ $rental_status(rental.rental_status) }}
                                </StatusBadge>
                            </td>
                            <td>
                                <StatusBadge :class="`delivery-${rental.delivery_status}`">
                                    {{ $delivery_status(rental.delivery_status) || '-' }}
                                </StatusBadge>
                            </td>
                            <!-- <td>
                                <StatusBadge :class="`claim-${rental.claim_status || 1}`">
                                    <span v-if="Number(rental.claim_status) === 1">대기</span>
                                    <span v-else-if="Number(rental.claim_status) === 2">진행중</span>
                                    <span v-else-if="Number(rental.claim_status) === 3">완료</span>
                                    <span v-else>대기</span>
                                </StatusBadge>
                            </td> -->
                        </tr>
                    </tbody>
                </Table>

                <!-- * 페이지네이션 -->
                <PaginationContainer v-if="oxygenTotalItems > 10">
                    <PaginationButton :disabled="oxygenCurrentPage === 1" @click="changePage(1, 'oxygen')">
                        <ChevronDoubleLeft :size="17" class="chevron-icon" />
                    </PaginationButton>
                    <PaginationButton :disabled="oxygenCurrentPage === 1"
                        @click="changePage(oxygenCurrentPage - 1, 'oxygen')">
                        <ChevronLeft :size="17" class="chevron-icon" />
                    </PaginationButton>
                    <PaginationNumbers>
                        <PaginationNumber v-for="page in Math.ceil(oxygenTotalItems / 10)" :key="page"
                            :class="{ active: oxygenCurrentPage === page }" @click="changePage(page, 'oxygen')">
                            {{ page }}
                        </PaginationNumber>
                    </PaginationNumbers>
                    <PaginationButton :disabled="oxygenCurrentPage === Math.ceil(oxygenTotalItems / 10)"
                        @click="changePage(oxygenCurrentPage + 1, 'oxygen')">
                        <ChevronRight :size="17" class="chevron-icon" />
                    </PaginationButton>
                    <PaginationButton :disabled="oxygenCurrentPage === Math.ceil(oxygenTotalItems / 10)"
                        @click="changePage(Math.ceil(oxygenTotalItems / 10), 'oxygen')">
                        <ChevronDoubleRight :size="17" class="chevron-icon" />
                    </PaginationButton>
                </PaginationContainer>
            </GridItem>

            <!-- !보장구 청구 및 대여 섹션 -->
            <GridItem>
                <SectionHeader>
                    <Title>보장구 청구<Count type="assistance">{{ assistanceTotalItems }}건</Count>
                    </Title>
                </SectionHeader>

                <SearchSection>
                    <SearchGroup>
                        <SearchInput v-model="assistanceSearchQuery" placeholder="수급자 검색"
                            @keyup.enter="fetchRentals('assistance')" />
                        <HanqBtn @click="fetchRentals('assistance')">
                            <Magnify />
                        </HanqBtn>

                        <AllButton :class="{ active: assistanceSelectedMonth === null }"
                            @click="searchByMonth(null, 'assistance')">
                            전체
                        </AllButton>
                    </SearchGroup>
                    <DateRange>
                        <Datepicker v-model:value="assistanceStartDate" placeholder="시작일" style="width: 120px;"
                            :lang="ko" />
                        ~
                        <Datepicker v-model:value="assistanceEndDate" placeholder="종료일" style="width: 120px;"
                            :lang="ko" />
                        <SearchButton @click="fetchRentals('assistance')">날짜조회</SearchButton>
                    </DateRange>
                </SearchSection>
                <Table>
                    <colgroup>
                        <col width="6%" /> <!-- No -->
                        <col width="20%" /> <!-- 성함 -->
                        <col width="20%" /> <!-- 품목명 -->
                        <col width="20%" /> <!-- 담당자 -->
                        <col width="20%" /> <!-- 청구일 -->
                        <!-- <col width="14%" /> 청구여부 -->
                    </colgroup>
                    <thead>
                        <tr>
                            <th>No</th>
                            <th>성함</th>
                            <th>품목명</th>
                            <th>담당자</th>
                            <th>청구일</th>
                            <!-- <th>청구여부</th> -->
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(rental, i) in assistanceRentals" :key="rental.num"
                            @click="openOrderRentalModal(rental)"
                            :class="{ 'ending-soon': isRentalEndingSoon(rental.rental_end), 'blurred': isTestUser }">
                            <td>{{ ((assistanceCurrentPage - 1) * 10) + i + 1 }}</td>
                            <td>{{ rental.name }}</td>
                            <td>{{ formatProductName(rental.product_name) }}</td>
                            <td>{{ rental.manager }}</td>
                            <td>{{ rental.rental_start }}</td>
                            <!-- <td>
                                <StatusBadge :class="`claim-${rental.claim_status || 1}`">
                                    <span v-if="Number(rental.claim_status) === 1">대기</span>
                                    <span v-else-if="Number(rental.claim_status) === 2">진행중</span>
                                    <span v-else-if="Number(rental.claim_status) === 3">완료</span>
                                    <span v-else>대기</span>
                                </StatusBadge>
                            </td> -->
                        </tr>
                    </tbody>
                </Table>

                <!-- * 페이지네이션 -->
                <PaginationContainer v-if="assistanceTotalItems > 10">
                    <PaginationButton :disabled="assistanceCurrentPage === 1" @click="changePage(1, 'assistance')">
                        <ChevronDoubleLeft :size="17" class="chevron-icon" />
                    </PaginationButton>
                    <PaginationButton :disabled="assistanceCurrentPage === 1"
                        @click="changePage(assistanceCurrentPage - 1, 'assistance')">
                        <ChevronLeft :size="17" class="chevron-icon" />
                    </PaginationButton>
                    <PaginationNumbers>
                        <PaginationNumber v-for="page in Math.ceil(assistanceTotalItems / 10)" :key="page"
                            :class="{ active: assistanceCurrentPage === page }" @click="changePage(page, 'assistance')">
                            {{ page }}
                        </PaginationNumber>
                    </PaginationNumbers>
                    <PaginationButton :disabled="assistanceCurrentPage === Math.ceil(assistanceTotalItems / 10)"
                        @click="changePage(assistanceCurrentPage + 1, 'assistance')">
                        <ChevronRight :size="17" class="chevron-icon" />
                    </PaginationButton>
                    <PaginationButton :disabled="assistanceCurrentPage === Math.ceil(assistanceTotalItems / 10)"
                        @click="changePage(Math.ceil(assistanceTotalItems / 10), 'assistance')">
                        <ChevronDoubleRight :size="17" class="chevron-icon" />
                    </PaginationButton>
                </PaginationContainer>
            </GridItem>

            <!-- ! 당뇨소모성재료 관리 섹션 -->
            <GridItem>
                <SectionHeader>
                    <Title>당뇨소모성재료 청구<Count type="diabetes">{{ diabetesTotalItems }}건</Count>
                    </Title>
                </SectionHeader>

                <SearchSection>
                    <SearchGroup>
                        <SearchInput v-model="diabetesSearchQuery" placeholder="수급자 검색"
                            @keyup.enter="fetchRentals('diabetes')" />
                        <HanqBtn @click="fetchRentals('diabetes')">
                            <Magnify />
                        </HanqBtn>
                        <AllButton :class="{ active: diabetesSelectedMonth === null }"
                            @click="searchByMonth(null, 'diabetes')">
                            전체
                        </AllButton>
                    </SearchGroup>
                    <DateRange>
                        <Datepicker v-model:value="diabetesStartDate" placeholder="시작일" style="width: 120px;"
                            :lang="ko" />
                        ~
                        <Datepicker v-model:value="diabetesEndDate" placeholder="종료일" style="width: 120px;"
                            :lang="ko" />
                        <SearchButton @click="fetchRentals('diabetes')">날짜조회</SearchButton>
                    </DateRange>
                </SearchSection>
                <Table>
                    <colgroup>
                        <col width="6%" /> <!-- No -->
                        <col width="10%" /> <!-- 성함 -->
                        <col width="39%" /> <!-- 품목명 -->
                        <col width="10%" /> <!-- 담당자 -->
                        <col width="15%" /> <!-- 당뇨시작일 -->
                        <col width="15%" /> <!-- 당뇨종료일 -->
                        <!-- <col width="10%" /> 청구여부 -->
                    </colgroup>
                    <thead>
                        <tr>
                            <th>No</th>
                            <th>성함</th>
                            <th>품목명</th>
                            <th>담당자</th>
                            <th>당뇨처방시작일</th>
                            <th>당뇨처방종료일</th>
                            <!-- <th>청구여부</th> -->
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(rental, i) in diabetesRentals" :key="rental.num"
                            @click="openOrderRentalModal(rental)"
                            :class="{ 'ending-soon': isRentalEndingSoon(rental.rental_end), 'blurred': isTestUser }">
                            <td>{{ ((diabetesCurrentPage - 1) * 10) + i + 1 }}</td>
                            <td>{{ rental.name }}</td>
                            <td>{{ formatProductName(rental.product_name) }}</td>
                            <td>{{ rental.manager }}</td>
                            <td>{{ formatDate(rental.diabetes_start) }}</td>
                            <td>{{ formatDate(rental.diabetes_end) }}</td>
                            <!-- <td>
                                <StatusBadge :class="`claim-${rental.claim_status || 1}`">
                                    <span v-if="Number(rental.claim_status) === 1">대기</span>
                                    <span v-else-if="Number(rental.claim_status) === 2">진행중</span>
                                    <span v-else-if="Number(rental.claim_status) === 3">완료</span>
                                    <span v-else>대기</span>
                                </StatusBadge>
                            </td> -->
                        </tr>
                    </tbody>
                </Table>
            </GridItem>

            <!-- * 페이지네이션 -->
            <PaginationContainer v-if="diabetesTotalItems > 10">
                <PaginationButton :disabled="diabetesCurrentPage === 1" @click="changePage(1, 'diabetes')">
                    <ChevronDoubleLeft :size="17" class="chevron-icon" />
                </PaginationButton>
                <PaginationButton :disabled="diabetesCurrentPage === 1"
                    @click="changePage(diabetesCurrentPage - 1, 'diabetes')">
                    <ChevronLeft :size="17" class="chevron-icon" />
                </PaginationButton>
                <PaginationNumbers>
                    <PaginationNumber v-for="page in Math.ceil(diabetesTotalItems / 10)" :key="page"
                        :class="{ active: diabetesCurrentPage === page }" @click="changePage(page, 'diabetes')">
                        {{ page }}
                    </PaginationNumber>
                </PaginationNumbers>
                <PaginationButton :disabled="diabetesCurrentPage === Math.ceil(diabetesTotalItems / 10)"
                    @click="changePage(diabetesCurrentPage + 1, 'diabetes')">
                    <ChevronRight :size="17" class="chevron-icon" />
                </PaginationButton>
                <PaginationButton :disabled="diabetesCurrentPage === Math.ceil(diabetesTotalItems / 10)"
                    @click="changePage(Math.ceil(diabetesTotalItems / 10), 'diabetes')">
                    <ChevronDoubleRight :size="17" class="chevron-icon" />
                </PaginationButton>
            </PaginationContainer>
        </GridContainer>

        <!-- ! 알림 모달 -->
        <ModalPage v-model:show="showAlertModal" :height="modal_height" :width="'600px'">
            <AlertModal :show="showAlertModal" :type="alertModalType" :title="alertModalTitle"
                @close="closeAlertModal" />
        </ModalPage>

        <!-- !대여 주문 모달 -->
        <ModalPage v-model:show="showRentalModal" :height="modal_height" :parent="'rentalOrder'">
            <OrderRentalPage v-if="selectedRental.num" :orderId="selectedRental.num" :orderData="selectedRental"
                :products="selectedRental.products" @close="closeOrderRentalModal"
                @rental-status-updated="handleRentalStatusUpdate" />
        </ModalPage>

        <!-- !산소발생기 관리 모달 -->
        <ModalPage v-model:show="showOxygenModal" @close="closeOxygenModal" :height="'80%'" :width="'80%'">
            <OxygenModal />
        </ModalPage>
    </Container>
</template>

<script>
import * as RentalCss from '@/assets/styles/rental/RentalCss';
import OrderRentalPage from '@/components/Rental/modal/OrderRentalModal.vue';
import ModalPage from '@/components/layout/ModalPage.vue';
import OxygenModal from './modal/OxygenModal.vue';
import AlertModal from '@/components/layout/AlertModal.vue';

import Magnify from 'vue-material-design-icons/Magnify.vue';
import ChevronLeft from 'vue-material-design-icons/ChevronLeft.vue';
import ChevronRight from 'vue-material-design-icons/ChevronRight.vue';
import ChevronDoubleLeft from 'vue-material-design-icons/ChevronDoubleLeft.vue';
import ChevronDoubleRight from 'vue-material-design-icons/ChevronDoubleRight.vue';
import Datepicker from 'vue-datepicker-next';
import 'vue-datepicker-next/index.css';

export default {
    name: 'RentalPage',

    components: {
        ...RentalCss,
        OrderRentalPage,
        ModalPage,
        OxygenModal,
        AlertModal,
        Magnify,
        ChevronLeft,
        ChevronRight,
        ChevronDoubleLeft,
        ChevronDoubleRight,
        Datepicker,
    },

    setup() {
        const ko = {
            formatLocale: {
                months: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
                monthsShort: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
                weekdays: ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일'],
                weekdaysShort: ['일', '월', '화', '수', '목', '금', '토'],
                weekdaysMin: ['일', '월', '화', '수', '목', '금', '토'],
                firstDayOfWeek: 0,
                firstWeekContainsDate: 1,
                meridiem: (h) => (h < 12 ? '오전' : '오후'),
                meridiemParse: /오전|오후/,
                isPM: (input) => input === '오후'
            },
            yearFormat: 'YYYY년',
            monthFormat: 'MMM',
            monthBeforeYear: false
        };

        return {
            ko
        };
    },

    data() {
        const today = new Date();
        // 일반대여 날짜
        const basicStartDate = new Date(today.getFullYear(), today.getMonth(), 1);
        const basicEndDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        // 산소발생기 날짜
        const oxygenStartDate = new Date(today.getFullYear(), today.getMonth(), 1);
        const oxygenEndDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        // 보장구 날짜
        const assistanceStartDate = new Date(today.getFullYear(), today.getMonth(), 1);
        const assistanceEndDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        // 당뇨소모성재료 날짜
        const diabetesStartDate = new Date(today.getFullYear(), today.getMonth(), 1);
        const diabetesEndDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);

        return {
            format: {
                date: (date) => {
                    // date가 문자열인 경우 Date 객체로 변환
                    if (typeof date === 'string') {
                        date = new Date(date);
                    }

                    // 유효한 날짜인지 확인
                    if (!(date instanceof Date) || isNaN(date)) {
                        const today = new Date();
                        date = new Date(today.getFullYear(), today.getMonth(), 1);
                    }

                    const year = date.getFullYear();
                    const month = String(date.getMonth() + 1).padStart(2, '0');
                    const day = String(date.getDate()).padStart(2, '0');
                    return `${year}-${month}-${day}`;
                }
            },
            // 페이지네이션
            currentPage: 1,
            totalItems: 0,
            // 검색어 범위
            basicSearchQuery: '',
            oxygenSearchQuery: '',
            assistanceSearchQuery: '',
            diabetesSearchQuery: '',
            // 날짜 범위
            basicStartDate,
            basicEndDate,
            oxygenStartDate,
            oxygenEndDate,
            assistanceStartDate,
            assistanceEndDate,
            diabetesStartDate,
            diabetesEndDate,
            // 각 섹션별 데이터의 체크박스 상태
            rentalExtensionItems: [
                { checked: false },
            ],
            basicUnextendedItems: [
                { checked: false },
            ],
            uncontractedItems: [
                { checked: false },
            ],
            diabetesItem: [
                { checked: false },
            ],
            basicRentals: [],        // 일반대여
            oxygenRentals: [],      // 산소발생기
            assistanceRentals: [],   // 보장구
            diabetesRentals: [],    // 당뇨소모성재료

            // 각 섹션별 총 아이템 수
            basicTotalItems: 0,
            oxygenTotalItems: 0,
            assistanceTotalItems: 0,
            diabetesTotalItems: 0,

            // 각 섹션별 현재 페이지
            basicCurrentPage: 1,
            oxygenCurrentPage: 1,
            assistanceCurrentPage: 1,
            diabetesCurrentPage: 1,
            showRentalModal: false,
            selectedRental: {
                num: null,
                orderData: null,
                products: []
            },
            // 배송상태 필터
            basicSelectedFilter: null,
            oxygenSelectedFilter: null,
            assistanceSelectedFilter: null,
            deliveryStatusOptions: [
                { value: 1, label: '배송완료' },
                { value: 2, label: '배송대기' },
                { value: 3, label: '회수중' },
                { value: 4, label: '회수완료' },
                { value: 5, label: '배송중' }
            ],
            // 급여/비급여 필터
            basicPaymentFilter: null,
            assistancePaymentFilter: null,
            diabetesPaymentFilter: null,
            paymentTypeOptions: [
                { value: 'insurance', label: '급여' },
                { value: 'non_insurance', label: '비급여' }
            ],
            modal_height: '80%',
            showOxygenModal: false,
            showDiabetesModal: false,
            // 일반대여 관련
            basicSelectedMonth: null,
            basicSelectedYear: new Date().getFullYear(),

            // 산소발생기 관련
            oxygenSelectedMonth: null,
            oxygenSelectedYear: new Date().getFullYear(),

            // 보장구 관련
            assistanceSelectedMonth: null,
            assistanceSelectedYear: new Date().getFullYear(),

            // 당뇨소모성재료 관련
            diabetesSelectedMonth: null,
            diabetesSelectedYear: new Date().getFullYear(),

            // 상태 검색 필터
            statusFilterSelect: '',
            rentalStatusFilter: null,

            // 알림 모달 관련
            showAlertModal: false,
            alertModalType: 'rental',
            alertModalTitle: '대여 관리',
        };
    },

    computed: {
        isTestUser() {
            try {
                const userInfo = JSON.parse(localStorage.getItem('userInfo'));
                return userInfo && userInfo.id === 'test';
            } catch (error) {
                return false;
            }
        },
        formatProductName() {
            return (productName) => {
                if (!productName) return '';

                const products = productName.split(',');
                if (products.length <= 1) return productName;

                return `${products[0]} 외 ${products.length - 1}개`;
            };
        }
    },

    methods: {
        showInitialAlertModal() {
            this.alertModalType = 'rental';
            this.alertModalTitle = '대여 관리';
            this.showAlertModal = true;
            document.body.style.overflow = 'hidden';
        },

        closeAlertModal() {
            this.showAlertModal = false;
            document.body.style.overflow = 'auto';
        },

        // 상태 저장 섹션 ================================================================================
        saveState() {
            const state = {
                // 검색어
                basicSearchQuery: this.basicSearchQuery,
                oxygenSearchQuery: this.oxygenSearchQuery,
                assistanceSearchQuery: this.assistanceSearchQuery,

                // 날짜 범위
                basicStartDate: this.basicStartDate,
                basicEndDate: this.basicEndDate,
                oxygenStartDate: this.oxygenStartDate,
                oxygenEndDate: this.oxygenEndDate,
                assistanceStartDate: this.assistanceStartDate,
                assistanceEndDate: this.assistanceEndDate,

                // 페이지 정보
                basicCurrentPage: this.basicCurrentPage,
                oxygenCurrentPage: this.oxygenCurrentPage,
                assistanceCurrentPage: this.assistanceCurrentPage,

                // 필터 상태
                basicSelectedFilter: this.basicSelectedFilter,
                oxygenSelectedFilter: this.oxygenSelectedFilter,
                assistanceSelectedFilter: this.assistanceSelectedFilter,
                basicPaymentFilter: this.basicPaymentFilter,
                assistancePaymentFilter: this.assistancePaymentFilter,
                rentalStatusFilter: this.rentalStatusFilter,
                statusFilterSelect: this.statusFilterSelect,

                // 월 선택 상태
                basicSelectedMonth: this.basicSelectedMonth,
                oxygenSelectedMonth: this.oxygenSelectedMonth,
                assistanceSelectedMonth: this.assistanceSelectedMonth,
                basicSelectedYear: this.basicSelectedYear,
                oxygenSelectedYear: this.oxygenSelectedYear,
                assistanceSelectedYear: this.assistanceSelectedYear,

                // 모달 상태
                showRentalModal: this.showRentalModal,
                selectedRental: this.selectedRental,

                lastVisit: new Date().getTime() // 마지막 방문 시간 저장
            };

            localStorage.setItem('hanqPageState', JSON.stringify(state));

            // 새로고침 감지를 위한 세션 스토리지 설정
            sessionStorage.setItem('hanqPageVisited', 'true');
        },

        // 상태 복원 메서드 추가
        restoreState() {
            const isRefresh = sessionStorage.getItem('hanqPageVisited') === 'true';

            // 새로고침인 경우 상태를 복원하지 않고 초기화
            if (isRefresh) {
                localStorage.removeItem('hanqPageState');
                sessionStorage.removeItem('hanqPageVisited');
                return;
            }

            const savedState = localStorage.getItem('hanqPageState');
            if (!savedState) return;

            try {
                const state = JSON.parse(savedState);

                // 검색어 복원
                this.basicSearchQuery = state.basicSearchQuery || '';
                this.oxygenSearchQuery = state.oxygenSearchQuery || '';
                this.assistanceSearchQuery = state.assistanceSearchQuery || '';

                // 날짜 범위 복원
                if (state.basicStartDate) this.basicStartDate = new Date(state.basicStartDate);
                if (state.basicEndDate) this.basicEndDate = new Date(state.basicEndDate);
                if (state.oxygenStartDate) this.oxygenStartDate = new Date(state.oxygenStartDate);
                if (state.oxygenEndDate) this.oxygenEndDate = new Date(state.oxygenEndDate);
                if (state.assistanceStartDate) this.assistanceStartDate = new Date(state.assistanceStartDate);
                if (state.assistanceEndDate) this.assistanceEndDate = new Date(state.assistanceEndDate);

                // 페이지 정보 복원
                this.basicCurrentPage = state.basicCurrentPage || 1;
                this.oxygenCurrentPage = state.oxygenCurrentPage || 1;
                this.assistanceCurrentPage = state.assistanceCurrentPage || 1;

                // 필터 상태 복원
                this.basicSelectedFilter = state.basicSelectedFilter;
                this.oxygenSelectedFilter = state.oxygenSelectedFilter;
                this.assistanceSelectedFilter = state.assistanceSelectedFilter;
                this.basicPaymentFilter = state.basicPaymentFilter;
                this.assistancePaymentFilter = state.assistancePaymentFilter;
                this.rentalStatusFilter = state.rentalStatusFilter;
                this.statusFilterSelect = state.statusFilterSelect || '';

                // 월 선택 상태 복원
                this.basicSelectedMonth = state.basicSelectedMonth;
                this.oxygenSelectedMonth = state.oxygenSelectedMonth;
                this.assistanceSelectedMonth = state.assistanceSelectedMonth;
                this.basicSelectedYear = state.basicSelectedYear || new Date().getFullYear();
                this.oxygenSelectedYear = state.oxygenSelectedYear || new Date().getFullYear();
                this.assistanceSelectedYear = state.assistanceSelectedYear || new Date().getFullYear();

                // 모달 상태 복원 추가
                if (state.selectedRental && state.selectedRental.num) {
                    this.selectedRental = state.selectedRental;

                    // 모달이 열려있었다면 다시 열기
                    if (state.showRentalModal) {
                        // 약간의 지연을 두고 모달 열기 (데이터 로딩 후)
                        setTimeout(() => {
                            this.showRentalModal = true;
                            document.body.style.overflow = 'hidden';
                        }, 300);
                    }
                }

            } catch (error) {
                console.error('상태 복원 중 오류 발생:', error);
                localStorage.removeItem('hanqPageState');
            }
        },

        // 상태 필터 적용 메서드
        applyStatusFilterSelect(type) {
            console.log("상태 필터 선택:", this.statusFilterSelect);

            // 필터 초기화
            this.basicSelectedFilter = null;
            this.rentalStatusFilter = null;

            if (!this.statusFilterSelect || this.statusFilterSelect === '') {
                this.fetchRentals(type);
                return;
            }

            const [filterType, filterValue] = this.statusFilterSelect.split('_');
            const numericValue = parseInt(filterValue);

            if (filterType === 'rental') {
                // 대여상태 필터 적용
                this.rentalStatusFilter = numericValue;
            } else if (filterType === 'delivery') {
                // 배송상태 필터 적용
                this.basicSelectedFilter = numericValue;
            }

            this.fetchRentals(type);
            this.saveState();
        },

        isRentalEndingSoon(endDateStr) {
            if (!endDateStr) return false;

            const endDate = new Date(endDateStr);
            const today = new Date();

            // 현재 달과 같은지 확인
            return endDate.getMonth() === today.getMonth() &&
                endDate.getFullYear() === today.getFullYear();
        },

        searchByMonth(month, type = 'basic') {
            let selectedYear, startDate, endDate;

            switch (type) {
                case 'basic':  // 일반대여
                    this.basicSelectedMonth = month;
                    selectedYear = this.basicSelectedYear;
                    if (month === null) {
                        startDate = new Date(selectedYear, 0, 1);  // 해당 년도의 1월 1일
                        endDate = new Date(selectedYear, 11, 31);  // 해당 년도의 12월 31일
                    } else {
                        startDate = new Date(selectedYear, month - 1, 1);
                        endDate = new Date(selectedYear, month, 0);
                    }
                    this.basicStartDate = startDate;
                    this.basicEndDate = endDate;
                    this.fetchRentals('basic');
                    break;

                case 'oxygen':  // 산소발생기
                    this.oxygenSelectedMonth = month;
                    selectedYear = this.oxygenSelectedYear;
                    if (month === null) {
                        startDate = new Date(selectedYear, 0, 1);
                        endDate = new Date(selectedYear, 11, 31);
                    } else {
                        startDate = new Date(selectedYear, month - 1, 1);
                        endDate = new Date(selectedYear, month, 0);
                    }
                    this.oxygenStartDate = startDate;
                    this.oxygenEndDate = endDate;
                    this.fetchRentals('oxygen');
                    break;

                case 'assistance':  // 보장구
                    this.assistanceSelectedMonth = month;
                    selectedYear = this.assistanceSelectedYear;
                    if (month === null) {
                        startDate = new Date(selectedYear, 0, 1);
                        endDate = new Date(selectedYear, 11, 31);
                    } else {
                        startDate = new Date(selectedYear, month - 1, 1);
                        endDate = new Date(selectedYear, month, 0);
                    }
                    this.assistanceStartDate = startDate;
                    this.assistanceEndDate = endDate;
                    this.fetchRentals('assistance');
                    break;

                case 'diabetes': // 당뇨소모성재료
                    this.diabetesSelectedMonth = month;
                    selectedYear = this.diabetesSelectedYear;
                    if (month === null) {
                        startDate = new Date(selectedYear, 0, 1);
                        endDate = new Date(selectedYear, 11, 31);
                    } else {
                        startDate = new Date(selectedYear, month - 1, 1);
                        endDate = new Date(selectedYear, month, 0);
                    }
                    this.diabetesStartDate = startDate;
                    this.diabetesEndDate = endDate;
                    this.fetchRentals('diabetes');
                    break;
            }
            this.saveState();
        },

        formatDate(date) {
            if (!date) return '';
            const d = new Date(date);
            return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
        },

        // 산소발생기 관리 모달
        openOxygenModal() {
            this.showOxygenModal = true;
            document.body.style.overflow = 'hidden';
        },
        closeOxygenModal() {
            this.showOxygenModal = false;
            document.body.style.overflow = 'auto';
        },

        async handleRentalStatusUpdate(updatedRental) {
            // 업데이트된 대여 정보로 해당 항목만 업데이트
            if (updatedRental && updatedRental.orderId) {
                // 모든 섹션에서 해당 대여 항목 찾아 업데이트
                const updateRentalInList = (rentalList) => {
                    return rentalList.map(rental => {
                        if (rental.num === updatedRental.orderId) {
                            return {
                                ...rental,
                                rental_status: updatedRental.rental_status,
                                delivery_status: updatedRental.delivery_status,
                                rental_end: updatedRental.rental_end || rental.rental_end
                            };
                        }
                        return rental;
                    });
                };

                // 일반 대여 목록 업데이트
                this.basicRentals = updateRentalInList(this.basicRentals);

                // 산소발생기 목록 업데이트
                this.oxygenRentals = updateRentalInList(this.oxygenRentals);

                // 보장구 목록 업데이트
                this.assistanceRentals = updateRentalInList(this.assistanceRentals);

                // 당뇨소모성재료 목록 업데이트
                this.diabetesRentals = updateRentalInList(this.diabetesRentals);

            } else {
                // 업데이트 정보가 충분하지 않은 경우 전체 목록 새로고침
                await this.fetchRentals('basic');
                await this.fetchRentals('oxygen');
                await this.fetchRentals('assistance');
                await this.fetchRentals('diabetes');
            }
            this.saveState();
        },

        openOrderRentalModal(rental) {
            document.body.style.overflow = 'hidden';

            try {
                this.selectedRental = rental;
                this.showRentalModal = true;
                this.saveState();
            } catch (error) {
                console.error('Error opening order rental modal:', error);
            }
        },

        async closeOrderRentalModal(data = {}) {
            this.showRentalModal = false;
            document.body.style.overflow = 'auto';

            // 새로고침이 필요한 경우 데이터 다시 불러오기
            if (data.refresh) {
                await Promise.all([
                    this.fetchRentals('basic'),
                    this.fetchRentals('oxygen'),
                    this.fetchRentals('assistance'),
                    this.fetchRentals('diabetes')
                ]);
            }

            this.saveState();
        },

        // 섹션별 데이터 조회
        async fetchRentals(type = 'basic') {
            try {
                let searchQuery, startDate, endDate, currentPage, delivery_status, payment_type, rental_status, rental_type;

                switch (type) {
                    case 'basic':
                        searchQuery = this.basicSearchQuery;
                        startDate = this.basicStartDate;
                        endDate = this.basicEndDate;
                        currentPage = this.basicCurrentPage;
                        delivery_status = this.basicSelectedFilter;
                        payment_type = this.basicPaymentFilter;
                        rental_status = this.rentalStatusFilter;
                        rental_type = '';
                        break;
                    case 'oxygen':
                        searchQuery = this.oxygenSearchQuery;
                        startDate = this.oxygenStartDate;
                        endDate = this.oxygenEndDate;
                        currentPage = this.oxygenCurrentPage;
                        delivery_status = this.oxygenSelectedFilter;
                        rental_status = this.rentalStatusFilter;
                        rental_type = 'o';
                        break;
                    case 'assistance':
                        searchQuery = this.assistanceSearchQuery;
                        startDate = this.assistanceStartDate;
                        endDate = this.assistanceEndDate;
                        currentPage = this.assistanceCurrentPage;
                        delivery_status = this.assistanceSelectedFilter;
                        payment_type = this.assistancePaymentFilter;
                        rental_status = this.rentalStatusFilter;
                        rental_type = 'a';
                        break;
                    case 'diabetes':
                        searchQuery = this.diabetesSearchQuery;
                        startDate = this.diabetesStartDate;
                        endDate = this.diabetesEndDate;
                        currentPage = this.diabetesCurrentPage;
                        payment_type = this.diabetesPaymentFilter;
                        break;
                }

                const response = await this.$axios.post(`${this.$apiUrls.hanqmedi}/getRentalList`, {
                    params: {
                        rentalSearch: searchQuery || '',
                        startDate: this.format.date(startDate),
                        endDate: this.format.date(endDate),
                        companykey: this.$globalState.company_key,
                        page: currentPage,
                        type: type,
                        delivery_status: delivery_status,
                        payment_type: payment_type,
                        rental_status: rental_status,
                        rental_type: rental_type,
                        contentsSize: 10
                    }
                });

                const { rentals, totalItems } = response.data;

                if (searchQuery && searchQuery.trim() !== '' && (!rentals || rentals.length === 0)) {
                    this.$swal.fire({
                        title: '검색 결과 없음',
                        text: `"${searchQuery}" 검색 결과를 찾을 수 없습니다.`,
                        icon: 'info',
                        confirmButtonText: '확인'
                    });

                    console.log('검색 결과 없음 메시지 표시됨:', searchQuery);
                }

                const mappedRentals = rentals.map(rental => ({
                    num: rental.num,
                    name: rental.name,
                    number: rental.number,
                    product_name: rental.product_name,
                    manager: rental.manager,
                    rental_start: rental.rental_start,
                    rental_end: rental.rental_end,
                    diabetes_start: rental.diabetes_start,
                    diabetes_end: rental.diabetes_end,
                    rental_status: rental.rental_status,
                    delivery_status: rental.delivery_status,
                    claim_status: rental.claim_status,
                    checked: false
                }));

                switch (type) {
                    case 'basic':
                        this.basicRentals = mappedRentals;
                        this.basicTotalItems = parseInt(totalItems) || 0;
                        break;
                    case 'oxygen':
                        this.oxygenRentals = mappedRentals;
                        this.oxygenTotalItems = parseInt(totalItems) || 0;
                        break;
                    case 'assistance':
                        this.assistanceRentals = mappedRentals;
                        this.assistanceTotalItems = parseInt(totalItems) || 0;
                        break;
                    case 'diabetes':
                        this.diabetesRentals = mappedRentals;
                        this.diabetesTotalItems = parseInt(totalItems) || 0;
                        break;
                }
                this.saveState();

            } catch (error) {
                console.error('Error fetching rentals:', error);
                // 에러 시 해당 섹션의 데이터 초기화
                switch (type) {
                    case 'basic':
                        this.basicRentals = [];
                        this.basicTotalItems = 0;
                        this.basicCurrentPage = 1;
                        break;
                    case 'oxygen':
                        this.oxygenRentals = [];
                        this.oxygenTotalItems = 0;
                        this.oxygenCurrentPage = 1;
                        break;
                    case 'assistance':
                        this.assistanceRentals = [];
                        this.assistanceTotalItems = 0;
                        this.assistanceCurrentPage = 1;
                        break;
                    case 'diabetes':
                        this.diabetesRentals = [];
                        this.diabetesTotalItems = 0;
                        this.diabetesCurrentPage = 1;
                        break;
                }
            }
        },

        async changePage(page, type) {
            switch (type) {
                case 'basic':
                    this.basicCurrentPage = page;
                    break;
                case 'oxygen':
                    this.oxygenCurrentPage = page;
                    break;
                case 'assistance':
                    this.assistanceCurrentPage = page;
                    break;
                case 'diabetes':
                    this.diabetesCurrentPage = page;
                    break;
            }
            await this.fetchRentals(type);
            this.saveState();
        }
    },

    watch: {
        basicSelectedYear() {
            if (this.basicSelectedMonth) {
                this.searchByMonth(this.basicSelectedMonth, 'basic');
            }
        },
        oxygenSelectedYear() {
            if (this.oxygenSelectedMonth) {
                this.searchByMonth(this.oxygenSelectedMonth, 'oxygen');
            }
        },
        assistanceSelectedYear() {
            if (this.assistanceSelectedMonth) {
                this.searchByMonth(this.assistanceSelectedMonth, 'assistance');
            }
        },
        // 모달 상태 변경 감시 추가
        showRentalModal() {
            // 모달 상태가 변경될 때마다 상태 저장
            this.saveState();
        },
        // 선택된 대여 정보 변경 감시 추가
        selectedRental: {
            handler() {
                this.saveState();
            },
            deep: true
        }
    },

    async created() {
        try {
            // 페이지 첫 방문 여부 확인
            const isFirstVisit = !sessionStorage.getItem('hanqPageVisited');

            // 상태 복원
            this.restoreState();

            // 데이터 로드
            await Promise.all([
                this.fetchRentals('basic'),
                this.fetchRentals('oxygen'),
                this.fetchRentals('assistance'),
                this.fetchRentals('diabetes')
            ]);

            // 첫 방문인 경우 AlertModal 표시
            if (isFirstVisit) {
                this.showInitialAlertModal();
                // 방문 표시
                sessionStorage.setItem('hanqPageVisited', 'true');
            }
        } catch (error) {
            console.error('Error in created hook:', error);
        }
    },

    // 컴포넌트가 활성화될 때 세션 스토리지 설정
    activated() {
        sessionStorage.setItem('hanqPageVisited', 'true');
    },

    // 컴포넌트가 비활성화될 때 상태 저장
    deactivated() {
        this.saveState();
    },

    // 컴포넌트가 파괴될 때 상태 저장
    beforeUnmount() {
        document.body.style.overflow = 'auto';
        this.saveState();
        // 페이지를 떠날 때 세션 스토리지 제거
        sessionStorage.removeItem('hanqPageVisited');
    },
};
</script>

<style scoped>
.ending-soon {
    background-color: rgba(255, 99, 71, 0.15);
}

.ending-soon:hover {
    background-color: rgba(255, 99, 71, 0.25);
}

/* 블러 효과를 위한 CSS */
.blurred {
    filter: blur(4px) !important;
    pointer-events: auto;
    user-select: auto;
    -webkit-user-select: auto;
    -moz-user-select: auto;
    -ms-user-select: auto;
}

/* 블러된 요소 내부의 상호작용은 유지 */
.blurred * {
    pointer-events: auto;
    user-select: auto;
    -webkit-user-select: auto;
    -moz-user-select: auto;
    -ms-user-select: auto;
}
</style>